<template>
  <div>
    <div class="vip-page">
      <div class="vip-contain">
        <div class="vip-top">
          <img style="width: 412px;height: 256px;margin-top: 30px" src="@/assets/img/vip/serveCard.png" alt="" />
          <div class="vip-price">
            <p class="title">志愿填报服务卡</p>
            <p class="source">圆梦志愿平台数据来源省考试院</p>
            <p class="price">价格  <span class="price-span">¥{{num_money.value}}</span></p>
            <el-button class="buy-button" @click="toBuy()" v-if="parseInt($store.state.userinfo.membershipType) !== 1">立即购买</el-button>
            <p class="description">
              <span>适用考生：普通文理科考生</span><br/>
              <span>适用有效日期：有效期截止到用户自行选择高考年的９月１日为止（非高考年，高考期间仅提供数据查询）</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="detail-page">
        <div class="detail-contain">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="el-tabs">
            <el-tab-pane label="志愿卡详情" name="first">
                <img class="rectangle-image" src="@/assets/img/vip/vipDetail.png" alt="" />
            </el-tab-pane>
            <el-tab-pane label="权益对比" name="second">
              <!-- 会员对比 -->
              <div class="comparison-table">
                <div class="vip-table">
                   <div class="comparison-1-1 borderright"></div>
                  <div class="comparison-1-1 comparison-1-text">功能权益</div>
                  <div
                      class="comparison-1-1 comparison-1-2 bordertop bordercolor backYellow"
                  >
                    <img
                        class="tuijianicon"
                        src="@/assets/img/vip/tuijian.png"
                        alt=""
                    />
                    <div class="comparison-1-div">
                      <div class="comparison-1-vip">VIP用户</div>
                      <img src="@/assets/img/vip/vip.png" alt="" />
                    </div>
                  </div>
                  <div class="comparison-1-1 comparison-1-text">普通用户</div>
                </div>
                <div class="comparison-2 back">
                   <div class="comparison-2-1 borderright comparison-2-bold">规划</div>
                  <div class="comparison-2-1">性格职业测试</div>
                  <div class="comparison-2-1 bordercolor backcolor">测评＋报告</div>
                  <div class="comparison-2-1">测评</div>
                </div>
                <div class="comparison-2">
                   <div class="comparison-3-1 borderright comparison-2-bold">查询</div>
                  <div class="comparison-3-1 comparison-3-col">
                    <div>找大学</div>
                    <div>大学分数线</div>
                    <div>查专业</div>
                    <div>专业分数线</div>
                    <div>省控线</div>
                    <div>历年一分一段</div>
                  </div>
                  <div class="comparison-3-1 bordercolor backYellow comparison-3-col">
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                  </div>
                  <div class="comparison-3-1 comparison-3-col">
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                  </div>
                </div>
                <div class="comparison-2 back">
                   <div class="comparison-4-1 borderright comparison-2-bold">填报</div>
                  <div class="comparison-4-1 comparison-3-col">
                    <div>选科大数据</div>
                    <div>选科查询</div>
                    <div>院校对比</div>
                    <div>志愿匹配</div>
                    <div>录取概率</div>
                    <div>志愿表</div>
                    <div>学业管理</div>
                    <div>一键智能填报</div>
                  </div>
                  <div class="comparison-4-1 bordercolor comparison-3-col backcolor">
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                  </div>
                  <div class="comparison-4-1 comparison-3-col">
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <!-- <img src="@/assets/img/vip/no.png" alt="" /> -->
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <div>匹配前10条</div>
                    <div>匹配前10条</div>
                    <img src="@/assets/img/vip/no.png" alt="" />
                    <img src="@/assets/img/vip/no.png" alt="" />
                    <img src="@/assets/img/vip/no.png" alt="" />
                  </div>
                </div>
                <div class="comparison-2">
                   <div class="comparison-5-1 borderright comparison-2-bold">问答</div>
                  <div class="comparison-5-1 comparison-3-col">
                    <div>高考资讯</div>
                    <div>人工服务</div>
                  </div>
                  <div
                      class="comparison-5-1 bordercolor backYellow comparison-3-col borderbottom"
                  >
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                  </div>
                  <div class="comparison-5-1 comparison-3-col">
                    <img src="@/assets/img/vip/yes.png" alt="" />
                    <img src="@/assets/img/vip/yes.png" alt="" />
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
    </div>
  </div>
</template>

<script>
import {ajaxGetDictItems} from "@/api/api";

export default {
  name: "vip",
  components: {},
  data(){
    return {
      num_money: "",
      activeName: "first",
    };

  },
  created() {
    this.getmoney()
  },
  methods: {
    getmoney(){
      //获取线上的金额
      ajaxGetDictItems("vip_money").then((res) => {
        if (res.success) {
          this.num_money = res.result[0];
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    toBuy(){
      // if (!this.$store.state.userinfo) {
      //   this.$store.commit("setloginstate", true);
      //   return false;
      // }
      this.$store.commit("setmembertype", 0);
      this.$store.commit("setmemberstate", true);
      // this.$router.push({
      //   path: "vipp/vipPay",
      //   query: {
      //     money: 178,
      //   },
      // });
    }
  }
}
</script>

<style>
.vip-table{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.vip-page {
  background-color: #F7F7F9 ;
  .vip-contain{
    width: 1200px;
    margin: 0 auto;
    .vip-top{
      height: 368px;
      display: flex;
      flex-direction: row;
      .vip-price {
          margin-left: 24px;
          .title {
            margin: 30px 0;
            height: 24px;
            font-size: 24px;
            font-weight: 400;
            color: #000000;
            line-height: 12px;
          }

          .source {
            margin-top: 14px;
            width: 224px;
            height: 16px;
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            line-height: 12px;
          }

          .price {
            margin-top: 47px;
            height: 16px;
            font-size: 16px;
            font-weight: 400;
            color: #999999;
            line-height: 12px;
          }

          .price-span {
            width: 95px;
            height: 19px;
            font-size: 24px;
            font-weight: bold;
            color: #E83D00;
            line-height: 12px;
          }


          .buy-button {
            margin-top: 49px;
            width: 339px;
            height: 44px;
            background: #660874;
            border-radius: 8px;
            font-size: 20px;
            font-weight: bold;
            color: #FFFFFF;
          }

          .description {
            margin-top: 19px;
            height: 40px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 25px;
          }

        }
      }

  }
}

.detail-page {
  display: flex;
  justify-content: center;

  .detail-contain {
    width: 1200px;
    margin: 0 auto auto;
    position: relative;
    .el-tabs{
      /deep/.el-tabs__item.is-top{
        font-size: 18px;
        font-weight: bold;
      }
      /deep/.el-tabs__item.is-active{
        color: #660874 ;
      }
      /deep/.el-tabs__active-bar{
        background-color: purple;
      }
    }
    .comparison-table {
      width: 1200px;
      background: #ffffff;
      border-left: 1px solid #e5e5e5;
      border-right: 1px solid #e5e5e5;
      border-bottom: 1px solid #e5e5e5;
      border-top: 1px solid #e5e5e5;
      border-radius: 8px;
        .comparison-1-1 {
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          width: 399px;
          height: 192px;
        }
        .comparison-1-2 {
          position: relative;
          .tuijianicon {
            position: absolute;
            top: 0;
            left: 0;
          }
          .comparison-1-div {
            text-align: center;
            .comparison-1-vip {
              font-size: 20px;
              font-weight: bold;
              color: #64068f;
              margin-bottom: 19px;
            }
          }
        }
        .comparison-1-text {
          font-size: 20px;
          font-weight: bold;
          color: #000000;
        }
      .comparison-2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .comparison-2-1 {
          width: 399px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000000;
        }
        .comparison-3-1 {
          width: 399px;
          height: 360px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000000;
          box-sizing: border-box;
          padding: 22px 0px;
        }
        .comparison-4-1 {
          width: 399px;
          height: 420px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000000;
          box-sizing: border-box;
          padding: 22px 0px;
        }
        .comparison-5-1 {
          width: 399px;
          height: 121px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          color: #000000;
          box-sizing: border-box;
          padding: 22px 0px;
        }
        .comparison-3-col {
          display: flex;
          flex-direction: column !important;
          justify-content: space-between;
        }
        .comparison-2-bold {
          font-weight: bold;
        }
      }
      .back {
        background: #f5efff;
      }
      .borderright {
        border-right: 1px solid #e5e5e5;
      }
      .bordertop {
        border-top: 1px solid #efe1ff;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .borderbottom {
        border-bottom: 2px solid #efe1ff;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      .bordercolor {
        border-left: 2px solid #efe1ff;
        border-right: 2px solid #efe1ff;
        color: #58049b !important;
      }
      .backcolor{
        background-color: #eee1fa;
      }
      .backYellow {
        background: #f5efff;
      }
    }
    .rectangle-image {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
    }
  }
}



</style>